// Shared Framer Motion variants for UTSAVA Genesis — cinematic, GPU-accelerated.
const EASE = [0.22, 1, 0.36, 1];

export const pageTransition = {
    initial: { opacity: 0, y: 12, filter: "blur(2px)" },
    animate: { opacity: 1, y: 0, filter: "blur(0px)" },
    exit: { opacity: 0, y: -8, filter: "blur(2px)" },
    transition: { duration: 0.42, ease: EASE },
};

export const staggerContainer = {
    initial: {},
    animate: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
};

export const staggerItem = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE } },
};

export const fadeUp = {
    initial: { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
};
